import { IChannelRepository } from '../../ports/IChannelRepository';
import { ChannelFilters } from '../../../shared/types/ChannelFilters';

export class ListAllChannelsUseCase {
  constructor(private repo: IChannelRepository) {}
  execute(filters: ChannelFilters) {
    return this.repo.listAll(filters);
  }
}
